export const PRIMARY = '#13116B';
export const SECONDARY = '#0E1365';
export const LIGHT = '#ECE7F5';